import { render, staticRenderFns } from "./DefineWork.vue?vue&type=template&id=7b9b209a&scoped=true&"
import script from "./DefineWork.vue?vue&type=script&lang=js&"
export * from "./DefineWork.vue?vue&type=script&lang=js&"
import style0 from "./DefineWork.vue?vue&type=style&index=0&id=7b9b209a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9b209a",
  null
  
)

component.options.__file = "DefineWork.vue"
export default component.exports